/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from '../../registry/Component.type';

export const page: {
  root: Item<'Page'>;
  rowPanel: Item<'RowPanel'>;
  columnPanel: Item<'ColumnPanel'>;
  columnPanel1: Item<'ColumnPanel'>;
  columnPanel2: Item<'ColumnPanel'>;
  button: Item<'Button'>;
  card: Item<'Card'>;
  cardHeader: Item<'CardHeader'>;
  avatar: Item<'Avatar'>;
  iconButton: Item<'IconButton'>;
  cardContent: Item<'CardContent'>;
  cardActions: Item<'CardActions'>;
  button1: Item<'Button'>;
  pulseTip: Item<'PulseTip'>;
  pulseTip1: Item<'PulseTip'>;
  form: Item<'Form'>;
  iconButton1: Item<'IconButton'>;
  pulseTip2: Item<'PulseTip'>;
} = {
  avatar: {
    children: [],
    itemId: 'avatar',
    parent: 'cardHeader',
    props: {},
    type: 'Avatar',
  },
  button: {
    children: ['pulseTip'],
    itemId: 'button',
    parent: 'columnPanel',
    props: {
      startIcon: {
        iconName: 'check',
        iconType: 'light',
      },
      text: {
        type: 'text',
        value: 'Submit',
      },
    },
    type: 'Button',
  },
  button1: {
    children: [],
    itemId: 'button1',
    parent: 'cardActions',
    props: {
      startIcon: {
        iconName: 'check',
        iconType: 'light',
      },
      text: {
        type: 'text',
        value: 'Submit',
      },
    },
    type: 'Button',
  },
  card: {
    children: ['cardHeader', 'cardContent', 'pulseTip1', 'cardActions'],
    itemId: 'card',
    parent: 'columnPanel2',
    props: {},
    type: 'Card',
  },
  cardActions: {
    children: ['button1'],
    itemId: 'cardActions',
    parent: 'card',
    props: {},
    type: 'CardActions',
  },
  cardContent: {
    children: ['form'],
    itemId: 'cardContent',
    parent: 'card',
    props: {},
    type: 'CardContent',
  },
  cardHeader: {
    children: ['avatar', 'iconButton'],
    itemId: 'cardHeader',
    parent: 'card',
    props: {
      title: {
        type: 'text',
        value: 'Title',
      },
    },
    type: 'CardHeader',
  },
  columnPanel: {
    children: ['button'],
    itemId: 'columnPanel',
    parent: 'rowPanel',
    props: {},
    type: 'ColumnPanel',
  },
  columnPanel1: {
    children: ['iconButton1'],
    itemId: 'columnPanel1',
    parent: 'rowPanel',
    props: {},
    type: 'ColumnPanel',
  },
  columnPanel2: {
    children: ['card'],
    itemId: 'columnPanel2',
    parent: 'rowPanel',
    props: {},
    type: 'ColumnPanel',
  },
  form: {
    children: [],
    itemId: 'form',
    parent: 'cardContent',
    props: {},
    type: 'Form',
  },
  iconButton: {
    children: [],
    itemId: 'iconButton',
    parent: 'cardHeader',
    props: {},
    type: 'IconButton',
  },
  iconButton1: {
    children: ['pulseTip2'],
    itemId: 'iconButton1',
    parent: 'columnPanel1',
    props: {},
    type: 'IconButton',
  },
  pulseTip: {
    children: [],
    itemId: 'pulseTip',
    parent: 'button',
    props: {
      right: '-4px',
      tipText: 'Some information about this button...',
      top: '-4px',
    },
    type: 'PulseTip',
  },
  pulseTip1: {
    children: [],
    itemId: 'pulseTip1',
    parent: 'card',
    props: {
      tipText: 'Some information about this card...',
      top: '30px',
    },
    type: 'PulseTip',
  },
  pulseTip2: {
    children: [],
    itemId: 'pulseTip2',
    parent: 'iconButton1',
    props: {
      tipText: 'Some information about this icon button...',
    },
    type: 'PulseTip',
  },
  root: {
    children: ['rowPanel'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
  rowPanel: {
    children: ['columnPanel', 'columnPanel1', 'columnPanel2'],
    itemId: 'rowPanel',
    parent: 'root',
    props: {},
    type: 'RowPanel',
  },
};
